import React from 'react';
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Button, Paper, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

// Data
let id = 0;
function createData(name, calories, fat, carbs, protein) {
    id += 1;
    return { id, name, calories, fat, carbs, protein };
}

const rows = [
    createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
    createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
    createData("Eclair", 262, 16.0, 24, 6.0),
    createData("Cupcake", 305, 3.7, 67, 4.3),
    createData("Gingerbread", 356, 16.0, 49, 3.9),
];

const useStyles = makeStyles((theme)=>({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '70%',
        height: '85%',
        overflowY: 'scroll',
        overflowX: 'scroll'
    },
    btn: {
        marginTop: 16
    },
    cancelButton: {
        border: '2px solid #0097b2 !important',
        color: '#0097b2 !important',
        fontWeight: 'bold !important',
        fontSize: '16px !important',
        borderRadius: '8px !important',
        textTransform: 'none',
        margin: theme.spacing(2, 0, 2),
        marginRight:'20px',
        padding:'5px 20px',
    },
    submit: {
            backgroundColor: '#ff6468 !important',
            color: '#ffffff !important',
            fontWeight: 'bold !important',
            fontSize: '16px !important',
            borderRadius: '8px !important',
            padding: '8px 24px !important',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#ff6468 !important',
                opacity: 0.9,
            },
    },
}));


function ProfilesDataPreviewModal(props) {

    const { open, processData, previewData, handleClose } = props

    const classes = useStyles();

    const uploadAction = () => {
        processData();
    }

    const renderCellValue = (cellVal) => {
        if (cellVal instanceof Date) {
            return cellVal.toLocaleString();  // You can adjust the format as needed
        }
        return cellVal;  // Assuming all other values are renderable as-is
    }


    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.modalPaper}>

                        {/*<h2 id="transition-modal-title">{'CSV Profile | Data Preview  of (' + rows.length + ') Records'}</h2>*/}
                        <Box
                            sx={{
                                backgroundColor:'#fff',
                                position:'sticky',
                                zIndex:'1',
                                top:'0%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                p: 2,
                                borderRadius: 1,
                                boxShadow: 3,
                                mb:4,
                            }}
                        >
                        <Typography variant="h5" style={{ textAlign: 'center',p:'0 170px',marginTop:'20px', }}>
                            Please check if the following information is correct. If it is correct, click UPLOAD DATA.<br/>
                            If it’s incorrect, click CANCEL and resubmit the corrected spreadsheet file.
                        </Typography>

                        <Box sx={{display:'flex', mt:4, alignItems:'center', justifyContent:'center'}}>
                            <Button
                                className={classes.cancelButton}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>

                        <Button
                            type="submit"
                            className={classes.submit}
                            onClick={uploadAction}
                        >
                            Upload Data
                        </Button>

                        </Box>
                        </Box>
                        {
                            previewData && previewData.map((obj) =>
                                <Paper>
                                    <h2 id="transition-modal-title">{`${obj.title} | Data Preview  of (${obj.rows.length}) Records`}</h2>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {obj.columns.map( col =>  <TableCell>{col.name}</TableCell>)}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                obj.rows.map(
                                                    (item, index) => <TableRow key={index}>
                                                        { item.map(cellVal => <TableCell>{renderCellValue(cellVal)}</TableCell> ) }
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </Paper>
                            )
                        }

                    </div>
                </Fade>
            </Modal>
        </>
    );
}

export default ProfilesDataPreviewModal;